import { TOPIC_KNOWLEDGE } from "../../actions/action-types"
import { PENDING, FULFILLED } from "redux-promise-middleware"

const defaultState = {
    data: [],
    isFulfilled: false,
    isPending: false
}

export default (state = defaultState, action) => {
    const { type, meta, payload } = action
    switch (type) {
        case `${TOPIC_KNOWLEDGE}_${PENDING}`:
            return {
                data: state.data,
                isFulfilled: false,
                isPending: true
            }

        case `${TOPIC_KNOWLEDGE}_${FULFILLED}`:
            return {
                data: state.data
                    // Filter out duplicate knowledge
                    .filter(
                        ({ meta: storedMeta }) =>
                            storedMeta.id !== meta.id ||
                            storedMeta.topicID !== meta.topicID ||
                            storedMeta.startDate !== meta.startDate ||
                            storedMeta.approved !== meta.approved
                    )
                    .concat([{ meta, payload }]),
                isFulfilled: true,
                isPending: false
            }
        default:
            return state
    }
}
